module.exports = "/_next/static/images/ReplayData@2x-bd8bb9f3fee223631b0db4340f906ef0.webp";